// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2o1_A","name":"ConsentHeader_name__1HICa","birthday":"ConsentHeader_birthday__29R5w","skeleton":"ConsentHeader_skeleton__T-1IC"};